import {ReactNode} from 'react';
import {InfinityScroll} from '../../../../design-system/atoms/InfinityScroll/InfinityScroll';
import {Loading} from '../../../../design-system/atoms/Loading/Loading';
import {useInfiniteContentHomeNoticeQuery} from '../../../../wrapper/contentWrapper';

export interface ContentHomeNoticeMobileMoreFetcherHeadlessProps {
  seriesId: number;
  children?: ReactNode;
}

/**
 * 콘텐츠홈 소식
 */
export function ContentHomeNoticeMobileMoreFetcherHeadless({
  seriesId,
  children,
}: ContentHomeNoticeMobileMoreFetcherHeadlessProps) {
  const {
    isFetching: isMoreLoading,
    data,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteContentHomeNoticeQuery(
    {
      contentHomeNoticeInput: {seriesId, page: 0},
    },
    {
      initialPageParam: {contentHomeNoticeInput: {seriesId, page: 0}},
      getNextPageParam: (lastPage, pages) => {
        return lastPage.contentHomeNotice?.noticeListContainer?.isEnd
          ? undefined
          : {contentHomeNoticeInput: {seriesId, page: pages.length}};
      },
    }
  );

  if (!children) {
    return null;
  }
  if (!data?.pages[0].contentHomeNotice?.noticeListContainer) {
    return <>{children}</>;
  }
  return (
    <InfinityScroll
      isLoading={isMoreLoading}
      canLoadNextPage={!isMoreLoading && hasNextPage}
      requestNextPageData={fetchNextPage}
    >
      {children}
      {isMoreLoading && (
        <div className="flex-center-full">
          <Loading />
        </div>
      )}
    </InfinityScroll>
  );
}
